import React from "react";
import Modal from "../../../../../layout/modal";

function DeleteMatterModal({ show, matter, onOk, onCancel, onExtract }) {
  return (
    <Modal
      show={show}
      title="Delete Matter"
      body="Deletion is permanent. You should create a full extract prior to deletion."
      buttons={[
        {
          caption: "Complete Extract",
          onClick: onExtract,
          variant: "outline-primary",
          enabled: true,
          display: true
        },
        {
          caption: "delete",
          onClick: onOk,
          variant: "danger",
          enabled: true,
          display: true
        },
        {
          default: true,
          caption: "cancel",
          onClick: onCancel,
          variant: "primary",
          enabled: true,
          display: true
        }
      ]}
    >
      <div className="mt-3">
        <div className="fw-bold">{matter?.caption || "Matter"}</div>
        <div className="text-muted">This will delete the matter record.</div>
      </div>
    </Modal>
  );
}

export default DeleteMatterModal;
